module.exports = __webpack_public_path__ + "27ac3ae821ec02f01149c3a6678c0cae.svg";